import { Splide } from '@splidejs/splide';
import { onDocumentReady } from '../utils/events';

/**
 * About page brands carousel. Two Splide carousels (medical / skincare) toggled
 * by the "Sort by" pills; the hidden one is mounted lazily the first time it is
 * shown (Splide needs a laid-out, non-hidden container to measure widths).
 * No-ops on any page without the section.
 */
onDocumentReady(() => {
  const section = document.querySelector('.about-brands');
  if (!section) return;

  const mount = (root) => {
    if (root.dataset.mounted) return;

    const splide = new Splide(root, {
      perPage: 3,
      perMove: 1,
      gap: 'clamp(14px, 1.6vw, 26px)',
      arrows: true,
      pagination: true,
      speed: 500,
      breakpoints: {
        1024: { perPage: 2 },
        640: { perPage: 1, gap: '16px' },
      },
    });

    const bar = root.querySelector('.about-brands__progress-bar');
    const updateBar = () => {
      const end = splide.Components.Controller.getEnd() + 1;
      const rate = end > 0 ? Math.min((splide.index + 1) / end, 1) : 1;
      if (bar) bar.style.width = `${100 * rate}%`;
    };

    splide.on('mounted move updated resized', updateBar);
    splide.mount();
    root.dataset.mounted = '1';
  };

  const mountVisible = () => {
    section
      .querySelectorAll(
        '[data-collection]:not(.is-hidden) [data-about-carousel]'
      )
      .forEach(mount);
  };

  mountVisible();

  const controls = Array.from(
    section.querySelectorAll('.brand-toolbar [data-filter]')
  );
  const groups = Array.from(section.querySelectorAll('[data-collection]'));

  controls.forEach((btn) => {
    btn.addEventListener('click', () => {
      const filter = btn.dataset.filter;
      groups.forEach((g) => {
        g.classList.toggle('is-hidden', g.dataset.collection !== filter);
      });
      controls.forEach((b) => {
        b.classList.toggle('is-active', b.dataset.filter === filter);
      });
      mountVisible();
    });
  });
});
